import { render } from "./ChangePlanDialog.vue?vue&type=template&id=4ed49dd6"
import script from "./ChangePlanDialog.vue?vue&type=script&lang=js"
export * from "./ChangePlanDialog.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__